/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as StoreRouteRouteImport } from './routes/store/route'
import { Route as LeaderboardsRouteRouteImport } from './routes/leaderboards/route'
import { Route as HomeRouteRouteImport } from './routes/home/route'
import { Route as IndexRouteImport } from './routes/index'

const StoreIndexLazyRouteImport = createFileRoute('/store/')()
const LeaderboardsIndexLazyRouteImport = createFileRoute('/leaderboards/')()
const HomeIndexLazyRouteImport = createFileRoute('/home/')()

const StoreRouteRoute = StoreRouteRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaderboardsRouteRoute = LeaderboardsRouteRouteImport.update({
  id: '/leaderboards',
  path: '/leaderboards',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRouteRoute = HomeRouteRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreIndexLazyRoute = StoreIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StoreRouteRoute,
} as any).lazy(() => import('./routes/store/index.lazy').then((d) => d.Route))
const LeaderboardsIndexLazyRoute = LeaderboardsIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LeaderboardsRouteRoute,
} as any).lazy(() =>
  import('./routes/leaderboards/index.lazy').then((d) => d.Route),
)
const HomeIndexLazyRoute = HomeIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HomeRouteRoute,
} as any).lazy(() => import('./routes/home/index.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/leaderboards': typeof LeaderboardsRouteRouteWithChildren
  '/store': typeof StoreRouteRouteWithChildren
  '/home/': typeof HomeIndexLazyRoute
  '/leaderboards/': typeof LeaderboardsIndexLazyRoute
  '/store/': typeof StoreIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/home': typeof HomeIndexLazyRoute
  '/leaderboards': typeof LeaderboardsIndexLazyRoute
  '/store': typeof StoreIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/home': typeof HomeRouteRouteWithChildren
  '/leaderboards': typeof LeaderboardsRouteRouteWithChildren
  '/store': typeof StoreRouteRouteWithChildren
  '/home/': typeof HomeIndexLazyRoute
  '/leaderboards/': typeof LeaderboardsIndexLazyRoute
  '/store/': typeof StoreIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/leaderboards'
    | '/store'
    | '/home/'
    | '/leaderboards/'
    | '/store/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/home' | '/leaderboards' | '/store'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/leaderboards'
    | '/store'
    | '/home/'
    | '/leaderboards/'
    | '/store/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HomeRouteRoute: typeof HomeRouteRouteWithChildren
  LeaderboardsRouteRoute: typeof LeaderboardsRouteRouteWithChildren
  StoreRouteRoute: typeof StoreRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leaderboards': {
      id: '/leaderboards'
      path: '/leaderboards'
      fullPath: '/leaderboards'
      preLoaderRoute: typeof LeaderboardsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store/': {
      id: '/store/'
      path: '/'
      fullPath: '/store/'
      preLoaderRoute: typeof StoreIndexLazyRouteImport
      parentRoute: typeof StoreRouteRoute
    }
    '/leaderboards/': {
      id: '/leaderboards/'
      path: '/'
      fullPath: '/leaderboards/'
      preLoaderRoute: typeof LeaderboardsIndexLazyRouteImport
      parentRoute: typeof LeaderboardsRouteRoute
    }
    '/home/': {
      id: '/home/'
      path: '/'
      fullPath: '/home/'
      preLoaderRoute: typeof HomeIndexLazyRouteImport
      parentRoute: typeof HomeRouteRoute
    }
  }
}

interface HomeRouteRouteChildren {
  HomeIndexLazyRoute: typeof HomeIndexLazyRoute
}

const HomeRouteRouteChildren: HomeRouteRouteChildren = {
  HomeIndexLazyRoute: HomeIndexLazyRoute,
}

const HomeRouteRouteWithChildren = HomeRouteRoute._addFileChildren(
  HomeRouteRouteChildren,
)

interface LeaderboardsRouteRouteChildren {
  LeaderboardsIndexLazyRoute: typeof LeaderboardsIndexLazyRoute
}

const LeaderboardsRouteRouteChildren: LeaderboardsRouteRouteChildren = {
  LeaderboardsIndexLazyRoute: LeaderboardsIndexLazyRoute,
}

const LeaderboardsRouteRouteWithChildren =
  LeaderboardsRouteRoute._addFileChildren(LeaderboardsRouteRouteChildren)

interface StoreRouteRouteChildren {
  StoreIndexLazyRoute: typeof StoreIndexLazyRoute
}

const StoreRouteRouteChildren: StoreRouteRouteChildren = {
  StoreIndexLazyRoute: StoreIndexLazyRoute,
}

const StoreRouteRouteWithChildren = StoreRouteRoute._addFileChildren(
  StoreRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HomeRouteRoute: HomeRouteRouteWithChildren,
  LeaderboardsRouteRoute: LeaderboardsRouteRouteWithChildren,
  StoreRouteRoute: StoreRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
